export default "__VITE_ASSET__WjA$SiIz__"